<style>
.info {
    color: #999;
    font-size: 12px;
}

.user {
    color: #999;
    font-size: 12px;
}

.type-badge {
    padding: 3px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 15px;
    color: white;
    font-size: 12px;
    display: inline-block;
    line-height: 1em;
}

h1 {
    margin-top: 20px;
    margin-bottom: 5px;
    line-height: 1.3em;
}

#likes-holder {
    background-color: rgb(70, 70, 70);
    color: white;
    display: inline-block;
    text-align: center;
    border-radius: 11px;
    margin: 0px;
}

#likes {
    padding: 8px;
    background-color: rgb(70, 70, 70);
    color: white;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}

#like-button {
    margin: 0px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}

.badge {
    padding: 1px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 15px;
    margin-left: 5px;
    margin-right: 5px;
    background-color: rgb(123, 123, 123);
    color: white;
}

.item-view {
    word-wrap: break-word;
}

.new-controls {
    margin-top: 10px;
    width: 100%;
}

.tags-box {
    margin-top: 10px;
}

.tag-box {
    padding-left:3px;
    padding-right: 3px;
    font-size: 12px;
    border-radius: 5px;
    background-color: rgb(235, 235, 243);
    color: grey;
    display: inline-block;
    margin: 5px;
    margin-top: 0px;
    margin-left: 0px;
    cursor: pointer;
}

.tag-box:hover {
    background-color: rgb(70, 70, 70);
    color: white;
}

:global(.rich-content-holder img) {
    width: 100%;
    border-radius: 15px;
    margin-top: 5px;
    margin-bottom: 5px;
}

:global(.hide-images img) {
    display: none;
}

/*Municipal*/
.municipal-badge {
    padding: 5px;
    border-radius: 15px;
    color: white;
    font-size: 12px;
    display: inline-block;
    line-height: 1em;
    background-color: black;
    cursor: pointer;
    margin-left: 10px;
}

@media (max-width:972px) {
    h1 {
        font-size: 1.5em;
    }
}
</style>

<script>
import {push} from './pt-router/Router.svelte'
import * as Common from './Common.js'
import Comments from './Comments.svelte'
import PollDisplay from './PollDisplay.svelte'
import AddCommentWidget from './AddCommentWidget.svelte'
import ReportItemWidget from './ReportItemWidget.svelte'
import DeleteItemWidget from './DeleteItemWidget.svelte'
import ShareItemWidget from './Sharing/ShareItemWidget.svelte'

import { getContext } from 'svelte';
const { open } = getContext('simple-modal');
import ShareSheetModal from './Sharing/ShareSheetModal.svelte'

export let item;
export let removeItemWithId;

let itemUserArea;
let currentUser;
let showWidget = false;

const unsubsribe = Common.currentUser.subscribe(value => {
    currentUser = value
})

function addComment(newComment) {
    newComment.item_id = item.item_id;
    newComment.user_id = currentUser.user_id
    newComment.user = currentUser
    Common.postData('comment', newComment)
    .then(r => {
        if(!r.ok) {
            alert("Problem adding Comment. Please try again.")
            return
        }

        item.item_comments = item.item_comments.concat(Number(r.data))
        Common.currentUser.update(c => {
            c.user_commentcount += 1;
            return c
        })
        
        Common.CreateNotification({body: "Thank you for the comment!"}, 1000)
        Common.NotifyNewCommentBadges(currentUser)
    })
    hideWidget()
}

function reportItem(details) {
    let report = {
        user_id : currentUser.user_id,
        body : details,
        type : Common.REPORTTYPE_ITEM,
        ref_id :item.item_id
    }
    Common.postData('report', report)
    .then(r => {
        if(!r.ok) {
            alert("Problem reporting. Please try again.")
            return;
        }
        alert("Sucessfully Reported Item. Thank You.")
    })
    hideWidget()
}

function tryShowCommentWidget() {
    if(!currentUser) {
        Common.loginContext.update(v => "item/" + item.item_id)
        Common.CreateNotification({body: "You must login to contribute!"}, 1000)
        push('/login')
    }
    showWidget = 'comment';
}

function tryShowReportItemWidget() {
    if(!currentUser) {
        Common.loginContext.update(v => "item/" + item.item_id)
        Common.CreateNotification({body: "You must login to contribute!"}, 1000)
        push('/login')
    }
    showWidget = 'report';
}

function showDeleteItemWidget() {
    showWidget = 'delete';
}

function showShareWidget() {
    open(ShareSheetModal, {
        link: "https://plantogether.city/item/" + item.item_id,
        shareString: Common.getItemTypeString(item.item_type) + ": "  + item.item_title + " on Plan Together"},
    {content: { fontSize: '14px', lineHeight: '1.5em'}});
}

function deleteItem() {
    Common.deleteData('item/' + item.item_id)
    .then(r => {
        if(!r.ok) {
            alert("Problem Deleting Item. Please try again.")
            return
        }

        removeItemWithId(item.item_id);
        push('/')
    })
    hideWidget()
}

function hideWidget() {
    showWidget = false;
}

function trylikeItem() {
    if(!currentUser) {
        Common.loginContext.update(v => "item/" + item.item_id)
        push('/login')
        return;
    }
    fetch(
        'API_URL/item/like/' + item.item_id,
        {
            method: "POST",
            headers: new Headers({'content-type': 'application/json'}),
            credentials: "include"
        }
    ).then(r => {
        if(r.status == 208) {
            alert("You can only like an item once!");
            return;
        } else if(r.status != 200) {
            alert("Problem sending like!")
            return;
        }
        item.item_likes += 1;
        Common.currentUser.update(c => {
            c.user_likecount += 1;
            return c
        })
        Common.CreateNotification({body: "Thanks for the like!"}, 1000)
        Common.NotifyNewLikeBadges(currentUser);
    })
}

function tryDelete() {
    const deleteConfirmed = confirm("Are you sure you want to delete this item?");
    if(deleteConfirmed) {
        deleteItem();
    }
}

</script>
<svelte:head>
    <!-- Primary Meta Tags -->
    <title>{Common.getItemTypeString(item.item_type) + " : "  + item.item_title}</title>
    <meta name="title" content={Common.getItemTypeString(item.item_type) + " : "  + item.item_title}>
    <meta name="description" content={Common.stripHtml(Common.sanitizeContent(item.item_content))}>

    <!-- Open Graph / Facebook -->
    <meta property="og:type" content="website">
    <meta property="og:url" content={"https://plantogether.city/item/" + item.item_id}>
    <meta property="og:title" content={Common.getItemTypeString(item.item_type) + " - "  + item.item_title}>
    <meta property="og:description" content={Common.stripHtml(Common.sanitizeContent(item.item_content))}>
    <meta property="og:image" content={"API_URL/item-image/" + item.item_id + ".png"}>

    <!-- Twitter -->
    <meta property="twitter:card" content="summary_large_image">
    <meta property="twitter:url" content={"https://plantogether.city/item/" + item.item_id}>
    <meta property="twitter:title" content={Common.getItemTypeString(item.item_type) + " - "  + item.item_title}>
    <meta property="twitter:description" content={Common.stripHtml(Common.sanitizeContent(item.item_content))}>
    <meta property="twitter:image" content={"API_URL/item-image/" + item.item_id + ".png"}>
</svelte:head>

{#if item}
<div class="item-view">
    <div>
        <div class="type-badge" style={"background-color:" + Common.getItemTypeColorString(item.item_type) + ";"}>
            {Common.getItemTypeString(item.item_type)}
        </div>
        <span class="info" style="padding-left: 10px;"><a href={"#/area/" + item.item_area_id}>{item.item_area_name}</a></span>
        <!--
        <span class="info" style="padding-left: 10px;">({item.item_latitude}, {item.item_longitude})</span>
        -->
        {#if item.item_handled_id === 0}
            <span class="municipal-badge">Area Official Saw Item</span>
        {:else if item.item_handled_id > 0}
            <span class="municipal-badge">Area Official Commented On Item</span>
        {/if}
    </div>
    <div class="tags-box">
        {#each item.item_tags as tag}
            <div class='tag-box' on:click={() => push("/tag/"+tag)}>
                # {tag}
            </div>
        {/each}
    </div>
        <h1 >{item.item_title}</h1>
        <div class="user">
            {#if !item.user_name}
                <strong>Deleted User</strong>
            {:else}
                <a style={item.user_area_id ? "color: rgb(123, 123, 123); font-weight: bold" : ""} href={"#/user/" + item.item_userid}>{item.user_name}</a>
                {#if item.user_area_id}<span class="badge">{item.user_area_name} Area Official</span>{/if}
            {/if}
                {Common.UnixTimeToDateStr(item.item_createtime)}
        </div>

    <p class={"rich-content-holder"}>
        {@html item.item_screened ? Common.sanitizeContent(item.item_content) : Common.ReplaceImagesIfNeeded(Common.sanitizeContent(item.item_content))}
    </p>
    {#if item.item_type === Common.ITEMTYPE_POLL}
        <PollDisplay item_id={item.item_id}></PollDisplay>
    {/if}

    <div class="new-controls">
        <div class="control">
            <div class="control-number">{item.item_likes}</div>
            <div class="control-button" on:click={trylikeItem}>Like</div>
        </div>
        <div class="control-single" on:click={tryShowCommentWidget}>Comment</div>
        <div class="control-single" on:click={showShareWidget}>Share</div>
        <div class="control-single" on:click={tryShowReportItemWidget}>Report</div>
        {#if currentUser && (currentUser.user_id == item.item_userid)}
            <div class="control-single" on:click={tryDelete}>Delete</div>
        {/if}
    </div>

    {#if showWidget == 'comment'}
        <AddCommentWidget {addComment} {hideWidget}></AddCommentWidget>
    {:else if showWidget == 'report'}
        <ReportItemWidget {reportItem} {hideWidget}></ReportItemWidget>
    {:else if showWidget == 'delete'}
        <DeleteItemWidget {deleteItem} {hideWidget}></DeleteItemWidget>
    {:else if showWidget == 'share'}
        <ShareItemWidget {item} {hideWidget}></ShareItemWidget>
    {/if}
    <Comments item_id={item.item_id} comments={item.item_comments}></Comments>
</div>
{/if}